export default {
  A1: 'D1',
  A2: 'D2',
  A3: 'D3',
  A4: 'D4',
  A5: 'D5',
  A6: 'D6',
  A7: 'D7',
  A8: 'D8',
  A9: 'D9',
  A10: 'D10',
  A11: 'D11',
  A12: 'D12',
  E1: 'B8',
  E2: 'B9',
  E3: 'B10',
  E4: 'B11',
  E5: 'B12',
  E6: 'C8',
  E7: 'C9',
  E8: 'C10',
  E9: 'C11',
  E10: 'C12',
  E11: 'C13',
  E12: 'C14',
  B8: 'E1',
  B9: 'E2',
  B10: 'E3',
  B11: 'E4',
  B12: 'E5',
  C8: 'E6',
  C9: 'E7',
  C10: 'E8',
  C11: 'E9',
  C12: 'E10',
  D1: 'A1',
  D2: 'A2',
  D3: 'A3',
  D4: 'A4',
  D5: 'A5',
  D6: 'A6',
  D7: 'A7',
  D8: 'A8',
  D9: 'A9',
  D10: 'A10',
  D11: 'A11',
  D12: 'A12'
};
